// extracted by css-extract-rspack-plugin
export default {"cls1":"CenteredDiv-cls1_k79","cls2":"CenteredDiv-cls2_7Oz CenteredDiv-cls1_k79"};